module.exports = __webpack_public_path__ + "static/media/12.372491d3.png";